import * as React from "react";
import SignatureCanvas from "react-signature-canvas";
import "./Signature.css";
import { Globals } from "../../Globals";

interface SignatureProps {
    onChange: (dataURL: string | null) => void;
    initialData: string | null;
}

export class Signature extends React.Component<SignatureProps> {
    signature: any = null;
    lastSignatureURL: string | null = null;

    constructor(props: SignatureProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.initialData !== null) {
            const tempImage = new Image();

            tempImage.onload = () => {
                this.signature.clear();
                this.signature.getCanvas().getContext("2d").drawImage(tempImage, 0, 0);
            };

            tempImage.src = this.props.initialData;
            this.lastSignatureURL = this.props.initialData;
        } else {
            this.signature.clear();
        }
    }

    handleChange = () => {
        this.lastSignatureURL = this.signature.isEmpty() ? null : this.signature.getCanvas().toDataURL();
        this.props.onChange(this.lastSignatureURL);
    }

    render() {
        return (
            <div className={"Signature__root"}>
                {Globals.getLastUsedSignature() === null || this.lastSignatureURL !== null ? null :
                    <button
                        className={"btn btn-success btn-sm Signature__autoFill"}
                        onClick={() => {
                            this.signature.clear();
                            this.lastSignatureURL = Globals.getLastUsedSignature();
                            this.signature.fromDataURL(this.lastSignatureURL);
                            this.props.onChange(this.lastSignatureURL);
                        }}
                    >
                        Tap to sign
                    </button>
                }
                <SignatureCanvas
                    clearOnResize={false}
                    canvasProps={{ width: 500, height: 250, className: "Signature__canvas" }}
                    ref={(e: any) => this.signature = e}
                    onEnd={() => {
                        this.handleChange();
                    }}
                />
                <div className={"Signature__buttonContainer"}>
                    <button
                        className={"btn btn-default btn-sm"}
                        onClick={() => {
                            this.signature.clear();
                            this.handleChange();
                        }}
                    >
                        Clear
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/Signture.tsx